import React from "react";
import { MessageCircle, Phone } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { waLink, quoteMessage } from "@/lib/whatsapp";

export default function FloatingWhatsApp({ productName }) {
  const { settings } = useSettings();
  return (
    <a
      data-testid="floating-whatsapp-btn"
      href={waLink(settings.whatsapp_number, quoteMessage(productName))}
      target="_blank" rel="noreferrer"
      className="fixed bottom-[4.5rem] right-3 md:bottom-8 md:right-8 z-50 w-[60px] h-[60px] md:w-16 md:h-16 grid place-items-center overflow-visible bg-[#16A765] rounded-full shadow-[0_8px_20px_rgba(9,91,52,0.38)] hover:scale-105 transition-transform"
      aria-label="Chat on WhatsApp"
    >
      <span className="floating-whatsapp-pulse absolute inset-0 rounded-full pulse-dot bg-[#1FBF73] opacity-40"/>
      <span className="relative z-10 grid place-items-center text-white">
        <MessageCircle size={24} strokeWidth={1.8}/>
        <Phone className="absolute" size={10} strokeWidth={2.2}/>
      </span>
    </a>
  );
}
